export default [
  {
    "id": "mat-enem-0770",
    "numero": 2270,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Para que o pouso de um avião seja autorizado \nem um aeroporto, a aeronave deve satisfazer, \nnecessariamente, as seguintes condições de \nsegurança: \n \nI. a envergadura da aeronave (maior distância \nentre as pontas das asas do avião) deve ser, no \nmáximo, igual à medida da largura da pista; \n \nII. o comprimento da aeronave deve ser inferior \na 60 m; \n \nIII. a carga máxima (soma das massas da aero-\nnave e sua carga) não pode exceder 110 t. \n \nSuponha que a maior pista desse aeroporto \ntenha 0,045 km de largura, e que os modelos de \naviões utilizados pelas empresas aéreas, que \nutilizam esse aeroporto, sejam dados pela tabe-\nla. \n \n \nOs únicos aviões aptos a pousar nesse aeropor-\nto, de acordo com as regras de segurança, são \nos de modelos: \n \nA) A e C. \nB) A e B. \nC) B e D. \nD) B e E. \nE) C e E.",
    "alternativas": {
      "C": "B e D.",
      "D": "B e E.",
      "E": "C e E.",
      "B": "A e B."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 770,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0771",
    "numero": 2271,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Com o objetivo de trabalhar a concentração e a \nsincronia de movimentos dos alunos de uma de \nsuas turmas, um professor de educação física \ndividiu essa turma em três grupos (A, B e C) e \nestipulou a seguinte atividade: os alunos do \ngrupo A deveriam bater palmas a cada 2 s, os \nalunos do grupo B deveriam bater palmas a \ncada 3 s e os alunos do grupo C deveriam bater \npalmas a cada 4 s. \n \nO professor zerou o cronômetro e os três gru-\npos começaram a bater palmas quando ele \nregistrou 1 s. Os movimentos prosseguiram até \no cronômetro registrar 60 s. \n \nUm estagiário anotou no papel a sequência \nformada pelos instantes em que os três grupos \nbateram palmas simultaneamente. \n \nQual é o termo geral da sequência anotada? \n \nA) 12 n, com n um número natural, tal que 1 ≤ n \n≤ 5. \nB) 24 n, com n um número natural, tal que 1 ≤ n \n≤ 2. \nC) 12 (n – 1), com n um número natural, tal que \n1 ≤ n ≤ 6. \nD) 12(n – 1) + 1, com n um número natural, tal \nque 1 ≤ n ≤ 5. \nE) 24 (n – 1) + 1, com n um número natural, tal \nque 1 ≤ n ≤ 3.",
    "alternativas": {
      "A": "12 n, com n um número natural, tal que 1 ≤ n ≤ 5.",
      "C": "12 (n – 1), com n um número natural, tal que 1 ≤ n ≤ 6.",
      "D": "12(n – 1) + 1, com n um número natural, tal que 1 ≤ n ≤ 5.",
      "E": "24 (n – 1) + 1, com n um número natural, tal que 1 ≤ n ≤ 3."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 771,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0772",
    "numero": 2272,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "A tabela apresenta parte do resultado de um \nespermograma (exame que analisa as condi-\nções físicas e composição do sêmen humano). \n \n \nPara analisar o exame, deve-se comparar os \nresultados obtidos em diferentes datas com o \nvalor padrão de cada característica avaliada. O \npaciente obteve um resultado dentro dos pa-\ndrões no exame realizado no dia: \n \nA) 30/11/2009.  \nB) 23/03/2010. \nC) 09/08/2011.  \nD) 23/08/2011. \nE) 06/03/2012.",
    "alternativas": {
      "B": "23/03/2010.",
      "D": "23/08/2011.",
      "E": "06/03/2012.",
      "A": "30/11/2009."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 772,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0773",
    "numero": 2273,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Admita que um tipo de eucalipto tenha expecta-\ntiva de crescimento exponencial, nos primeiros \nanos após seu plantio, modelado pela função \ny(t) = at – 1, na qual y representa a altura da plan-\nta em metro, t é considerado em ano, e a é uma \nconstante maior que 1. O gráfico representa a \nfunção y. \n \n \n \nAdmita ainda que y(0) fornece a altura da muda \nquando plantada, e deseja-se cortar os eucalip-\ntos quando as mudas crescerem 7,5 m após o \nplantio. \n \nO tempo entre a plantação e o corte, em ano, é \nigual a: \n \nA) 3. \nB) 4. \nC) 6. \nD) log2 7. \nE) log2 15.",
    "alternativas": {
      "E": "log2 15.",
      "A": "3.",
      "B": "4.",
      "C": "6."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 773,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0774",
    "numero": 2274,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Alguns equipamentos eletrônicos podem “quei-\nmar” durante o funcionamento quando sua tem-\nperatura interna atinge um valor máximo TM. \nPara maior durabilidade dos seus produtos, a \nindústria de eletrônicos conecta sensores de \ntemperatura a esses equipamentos, os quais \nacionam um sistema de resfriamento interno, \nligando-o quando a temperatura do eletrônico \nultrapassa um nível crítico Tc, e desligando-o \nsomente quando a temperatura cai para valores \ninferiores a Tm. O gráfico ilustra a oscilação da \ntemperatura interna de um aparelho eletrônico \ndurante as seis primeiras horas de funciona-\nmento, mostrando que seu sistema de resfria-\nmento interno foi acionado algumas vezes. \n \n \n \nQuantas foram as vezes que o sensor de tem-\nperatura acionou o sistema, ligando-o ou desli-\ngando-o? \n \nA) 2 \nB) 3 \nC) 4 \nD) 5 \nE) 9",
    "alternativas": {
      "C": "4",
      "D": "5",
      "A": "2",
      "B": "3"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 774,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0775",
    "numero": 2275,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Para estimular o raciocínio de sua filha, um pai \nfez o seguinte desenho e o entregou à criança \njuntamente com três lápis de cores diferentes. \nEle deseja que a menina pinte somente os cír-\nculos, de modo que aqueles que estejam liga-\ndos por um segmento tenham cores diferentes. \n \n \nA) 6. \nB) 12. \nC) 18. \nD) 24. \nE) 72.",
    "alternativas": {
      "C": "18.",
      "D": "24.",
      "E": "72.",
      "B": "12."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 775,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0776",
    "numero": 2276,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "A diretoria de uma empresa de alimentos resol-\nve apresentar para seus acionistas uma propos-\nta de novo produto. Nessa reunião, foram apre-\nsentadas as notas médias dadas por um grupo \nde consumidores que experimentaram o novo \nproduto e dois produtos similares concorrentes \n(A e B). \n \n \n \nA característica que dá a maior vantagem relati-\nva ao produto proposto e que pode ser usada, \npela diretoria para incentivar a sua produção é \na: \n \nA) textura. \nB) cor. \nC) tamanho. \nD) sabor. \nE) odor.",
    "alternativas": {
      "C": "tamanho.",
      "D": "sabor.",
      "E": "odor.",
      "A": "textura."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 776,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0777",
    "numero": 2277,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "O pacote de salgadinho preferido de uma meni-\nna é vendido em embalagens com diferentes \nquantidades. A cada embalagem é atribuído um \nnúmero de pontos na promoção: \n \n“Ao totalizar exatamente 12 pontos em embala-\ngens e acrescentar mais R$10,00 ao valor da \ncompra, você ganhará um bichinho de pelúcia”. \n \nEsse salgadinho é vendido em três embalagens \ncom as seguintes massas, pontos e preços: \n \n \n \nA menor quantia a ser gasta por essa menina \nque a possibilite levar o bichinho de pelúcia \nnessa promoção é: \nA) R$ 10,80. \nB) R$ 12,80. \nC) R$ 20,80. \nD) R$ 22,00. \nE) R$ 22,80.",
    "alternativas": {
      "C": "R$ 20,80.",
      "E": "R$ 22,80.",
      "A": "R$ 10,80.",
      "B": "R$ 12,80."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 777,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0778",
    "numero": 2278,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "O proprietário de um restaurante deseja com-\nprar um tampo de vidro retangular para a base \nde uma mesa, como ilustra a figura: \n \n \n \nSabe-se que a base da mesa, considerando a \nborda externa, tem a forma de um retângulo, \ncujos lados medem AC = 105cm e AB = 120cm. \n \nNa loja onde será feita a compra do tampo, exis-\ntem cinco tipos de opções de tampos, de dife-\nrentes dimensões, e todos com a mesma es-\npessura, sendo: \n \nTipo 1: 110 cm x 125 cm \nTipo 2: 115 cm x 125 cm \nTipo 3: 115 cm x 130 cm \nTipo 4: 120 cm x 130 cm \nTipo 5: 120 cm x 135 cm \n \nO proprietário avalia, para comodidade dos \nusuários, que se deve escolher o tampo de me-\nnor área possível que satisfaça a condição: ao \ncolocar o tampo sobre a base, de cada lado da \nborda externa da base da mesa, deve sobrar \numa região, correspondendo a uma moldura em \nvidro, limitada por um mínimo de 4 cm e máximo \nde 8 cm fora da base da mesa, de cada lado. \n \nSegundo as condições anteriores, qual é o tipo \nde tampo de vidro que o proprietário avaliou que \ndeve ser escolhido? \n \nA) 1 \nB) 2 \nC) 3 \nD) 4 \nE) 5",
    "alternativas": {
      "E": "5",
      "A": "1",
      "B": "2",
      "C": "3"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 778,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0780",
    "numero": 2280,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Um terreno retangular de lados cujas medidas, \nem metro, são x e y será cercado para a cons-\ntrução de um parque de diversões. Um dos la-\ndos do terreno encontra-se às margens de um \nrio. Observe a figura. \n \n \nPara cercar todo o terreno, o proprietário gasta-\nrá R$7500,00. O material da cerca custa R$4,00 \npor metro para os lados do terreno paralelos ao \nrio, e R$2,00 por metro para os demais lados. \n \nNessas condições, as dimensões do terreno e o \ncusto total do material podem ser relacionados \npela equação: \n \nA) 4(2x + y) = 7500 \nB) 4(x + 2y) = 7500 \nC) 2(x + y) = 7500 \nD) 2(4x + y) = 7500 \nE) 2(2x + y) = 7500",
    "alternativas": {
      "E": "2(2x + y) = 7500",
      "A": "4(2x + y) = 7500",
      "C": "2(x + y) = 7500",
      "D": "2(4x + y) = 7500"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 780,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0781",
    "numero": 2281,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Para comemorar o aniversário de uma cidade, a \nprefeitura organiza quatro dias consecutivos de \natrações culturais. A experiência de anos ante-\nriores mostra que, de um dia para o outro, o \nnúmero de visitantes no evento é triplicado. É \nesperada a presença de 345 visitantes para o \nprimeiro dia do evento. \n \nUma representação possível do número espe-\nrado de participantes para o último dia é: \n \nA) 3 x 345 \nB) (3 + 3 + 3) x 345 \nC) 33 x 345 \nD) 3 x 4 x 345 \nE) 34 x 345",
    "alternativas": {
      "E": "34 x 345",
      "A": "3 x 345",
      "C": "33 x 345",
      "D": "3 x 4 x 345"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 781,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0782",
    "numero": 2282,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "O recinto das provas de natação olímpica utiliza \na mais avançada tecnologia para proporcionar \naos nadadores condições ideais. Isso passa por \nreduzir o impacto da ondulação e das correntes \nprovocadas pelos nadadores no seu desloca-\nmento.  \n \nPara conseguir isso, a piscina de competição \ntem uma profundidade uniforme de 3 m que \najuda a diminuir a “reflexão” da água (o movi-\nmento contra uma superfície e o regresso no \nsentido contrário atingindo os nadadores), além \ndos já tradicionais 50 m de comprimento e 25 m \nde largura. Um clube deseja reformar sua pisci-\nna de 50 m de comprimento, 20 m de largura e \n2 m de profundidade de forma que passe a ter \nas mesmas dimensões das piscinas olímpicas. \n \nApós a reforma, a capacidade dessa piscina \nsuperará a capacidade da piscina original em \num valor mais próximo de: \n \nA) 20%. \nB) 25%. \nC) 47%. \nD) 50%. \nE) 88%.",
    "alternativas": {
      "D": "50%.",
      "E": "88%.",
      "A": "20%.",
      "B": "25%."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 782,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0783",
    "numero": 2283,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "O sódio está presente na maioria dos alimentos \nindustrializados, podendo causar problemas \ncardíacos em pessoas que ingerem grandes \nquantidades desses alimentos. Os médicos \nrecomendam que seus pacientes diminuam o \nconsumo de sódio. \n \nCom base nas informações nutricionais de cinco \nmarcas de biscoitos (A, B, C, D e E), construiu-\nse um gráfico, que relaciona quantidades de \nsódio com porções de diferentes biscoitos. \n \n \nQual das marcas de biscoito apresentadas tem \na menor quantidade de sódio por grama do pro-\nduto? \n \nA) A \nB) B \nC) C \nD) D \nE) E",
    "alternativas": {
      "D": "D",
      "A": "A",
      "B": "B",
      "C": "C"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 783,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0784",
    "numero": 2284,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Até novembro de 2011, não havia uma lei espe-\ncífica que punisse fraude em concursos públi-\ncos. Isso dificultava o enquadramento dos frau-\ndadores em algum artigo específico do Código \nPenal, fazendo com que eles escapassem da \nJustiça mais facilmente.  \n \nEntretanto, com o sancionamento da Lei \n12.550/11, é considerado crime utilizar ou divul-\ngar indevidamente o conteúdo sigiloso de con \ncurso público, com pena de reclusão de 12 a 48 \nmeses (1 a 4 anos). Caso esse crime seja co-\nmetido por um funcionário público, a pena sofre-\nrá um aumento de 1/3. \n \nSe um funcionário público for condenado por \nfraudar um concurso público, sua pena de re-\nclusão poderá variar de: \n \nA) 4 a 16 meses. \nB) 16 a 52 meses. \nC) 16 a 64 meses. \nD) 24 a 60 meses. \nE) 28 a 64 meses.",
    "alternativas": {
      "B": "16 a 52 meses.",
      "C": "16 a 64 meses.",
      "D": "24 a 60 meses.",
      "A": "4 a 16 meses."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 784,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0785",
    "numero": 2285,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Uma pessoa está disputando um processo de \nseleção para uma vaga de emprego em um \nescritório. Em uma das etapas desse processo, \nela tem de digitar oito textos. \n \nA quantidade de erros dessa pessoa, em cada \num dos textos digitados, é dada na tabela. \n \n \nNessa etapa do processo de seleção, os candi-\ndatos serão avaliados pelo valor da mediana do \nnúmero de erros. A mediana dos números de \nerros cometidos por essa pessoa é igual a: \n \nA) 2,0. \nB) 2,5. \nC) 3,0. \nD) 3,5. \nE) 4,0.",
    "alternativas": {
      "B": "2,5.",
      "C": "3,0.",
      "D": "3,5.",
      "E": "4,0."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 785,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0786",
    "numero": 2286,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "O gerente de um estacionamento, próximo a um \ngrande aeroporto, sabe que um passageiro que \nutiliza seu carro nos traslados casa-aeroporto-\ncasa gasta cerca de R$ 10,00 em combustível \nnesse trajeto. Ele sabe, também, que um pas-\nsageiro que não utiliza seu carro nos traslados \ncasa-aeroporto-casa gasta cerca de R$ 80,00 \ncom transporte. \n \nSuponha que os passageiros que utilizam seus \npróprios veículos deixem seus carros nesse \nestacionamento por um período de dois dias. \nPara tornar atrativo a esses passageiros o uso \ndo estacionamento, o valor, em real, cobrado \npor dia de estacionamento deve ser, no máxi-\nmo, de: \n \nA) 35,00. \nB) 40,00. \nC) 45,00. \nD) 70,00. \nE) 90,00.",
    "alternativas": {
      "C": "45,00.",
      "D": "70,00.",
      "E": "90,00.",
      "A": "35,00."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 786,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0787",
    "numero": 2287,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "O Índice de Massa Corporal (IMC) pode ser \nconsiderado uma alternativa prática, fácil e ba-\nrata para a medição direta de gordura corporal. \nSeu valor pode ser obtido pela fórmula          \nIMC = \nMassa\n(Altura)2, na qual a massa é em quilo-\ngrama e a altura, em metro. As crianças, natu-\nralmente, começam a vida com um alto índice \nde gordura corpórea, mas vão ficando mais \nmagras conforme envelhecem, por isso os cien-\ntistas criaram um IMC especialmente para as \ncrianças e jovens adultos, dos dois aos vinte \nanos de idade, chamado de IMC por idade. \n \nO gráfico mostra o IMC por idade para meninos. \n \n \n \nUma mãe resolveu calcular o IMC de seu filho, \num menino de dez anos de idade, com 1,20 m \nde altura e 30,92 kg. \n \nPara estar na faixa considerada normal de IMC, \nos valores mínimo e máximo que esse menino \nprecisa emagrecer, em quilograma, devem ser, \nrespectivamente, \n \nA) 1,12 e 5,12. \nB) 2,68 e 12,28. \nC) 3,47 e 7,47. \nD) 5,00 e 10,76. \nE) 7,77 e 11,77.",
    "alternativas": {
      "A": "1,12 e 5,12.",
      "B": "2,68 e 12,28.",
      "D": "5,00 e 10,76.",
      "E": "7,77 e 11,77."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 787,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0788",
    "numero": 2288,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Um produtor de maracujá usa uma caixa-\nd’água, com volume V, para alimentar o sistema \nde irrigação de seu pomar. O sistema capta \nágua através de um furo no fundo da caixa a \numa vazão constante. Com a caixa-d’água \ncheia, o sistema foi acionado às 7 h da manhã \nde segunda-feira. \n \nÀs 13 h do mesmo dia, verificou-se que já havi-\nam sido usados 15% do volume da água exis-\ntente na caixa. Um dispositivo eletrônico inter-\nrompe o funcionamento do sistema quando o \nvolume restante na caixa é de 5% do volume \ntotal, para reabastecimento. \n \nSupondo que o sistema funcione sem falhas, a \nque horas o dispositivo eletrônico interromperá \no funcionamento? \nA) Às 15 h de segunda-feira. \nB) Às 11 h de terça-feira. \nC) Às 14 h de terça-feira. \nD) Às 4 h de quarta-feira. \nE) Às 21 h de terça-feira.",
    "alternativas": {
      "A": "Às 15 h de segunda-feira.",
      "B": "Às 11 h de terça-feira.",
      "C": "Às 14 h de terça-feira.",
      "E": "Às 21 h de terça-feira."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 788,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0789",
    "numero": 2289,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Uma região de uma fábrica deve ser isolada, \npois nela os empregados ficam expostos a ris-\ncos de acidentes. Essa região está representa-\nda pela porção de cor cinza (quadrilátero de \nárea S) na figura. \n \n \n \nPara que os funcionários sejam orientados so-\nbre a localização da área isolada, cartazes in-\nformativos serão afixados por toda a fábrica. \nPara confeccioná-los, um programador utilizará \num software que permite desenhar essa região \na partir de um conjunto de desigualdades algé-\nbricas. \n \nAs desigualdades que devem ser utilizadas no \nreferido software, para o desenho da região de \nisolamento, são: \n \nA) 3y – x ≤ 0; 2y – x ≥ 0; y ≤ 8; x ≤ 9 \nB) 3y – x ≤ 0; 2y – x ≥ 0; y ≤ 9; x ≤ 8 \nC) 3y – x ≥ 0; 2y – x ≤ 0; y ≤ 9; x ≤ 8 \nD) 4y – 9x ≤ 0; 8y – 3x ≥ 0; y ≤ 8; x ≤ 9 \nE) 4y – 9x ≤ 0; 8y – 3x ≥ 0; y ≤ 9; x ≤ 8",
    "alternativas": {
      "C": "3y – x ≥ 0; 2y – x ≤ 0; y ≤ 9; x ≤ 8",
      "D": "4y – 9x ≤ 0; 8y – 3x ≥ 0; y ≤ 8; x ≤ 9",
      "E": "4y – 9x ≤ 0; 8y – 3x ≥ 0; y ≤ 9; x ≤ 8",
      "B": "3y – x ≤ 0; 2y – x ≥ 0; y ≤ 9; x ≤ 8"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 789,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0791",
    "numero": 2291,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Uma caixa-d’água em forma de um paralelepí-\npedo retângulo reto, com 4 m de comprimento, \n3 m de largura 2 m de altura, necessita de higi-\nenização. Nessa operação a caixa precisará ser \nesvaziada em 20 min, no máximo. A retirada da \nágua será feita com o auxílio de uma bomba de \nvazão constante, em que vazão é o volume do \nlíquido que passa pela bomba por unidade de \ntempo. \n \nA vazão mínima, em litro por segundo, que essa \nbomba deverá ter para que a caixa seja esvazi-\nada no tempo estipulado é: \nA) 2. \nB) 3. \nC) 5. \nD) 12. \nE) 20.",
    "alternativas": {
      "E": "20.",
      "A": "2.",
      "C": "5.",
      "D": "12."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 791,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0792",
    "numero": 2292,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Nas construções prediais são utilizados tubos \nde diferentes medidas para a instalação da rede \nde água. Essas medidas são conhecidas pelo \nseu diâmetro, muitas vezes medido em polega-\nda. Alguns desses tubos, com medidas em po-\nlegada, são os tubos de \n1\n2, \n3\n8 e \n5\n4. \n \nColocando os valores dessas medidas em or-\ndem crescente, encontramos: \n \nA) \n1\n2, \n3\n8, \n5\n4. \n \nB) \n1\n2, \n5\n4, \n3\n8. \n \nC) \n3\n8, \n1\n2, \n5\n4. \n \nD) \n3\n8, \n5\n4, \n1\n2. \n \nE) \n5\n4, \n1\n2, \n3\n8.",
    "alternativas": {
      "B": "1 2, 5 4, 3 8.",
      "C": "3 8, 1 2, 5 4.",
      "E": "5 4, 1 2, 3 8.",
      "A": "1 2, 3 8, 5 4."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 792,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0793",
    "numero": 2293,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Um lapidador recebeu de um joalheiro a enco-\nmenda para trabalhar em uma pedra preciosa \ncujo formato é o de uma pirâmide, conforme \nilustra a Figura 1. Para tanto, o lapidador fará \nquatro cortes de formatos iguais nos cantos da \nbase. Os cantos retirados correspondem a pe-\nquenas pirâmides, nos vértices P, Q. R e S, ao \nlongo dos segmentos tracejados, ilustrados na \nFigura 2. \n \n \n \nDepois de efetuados os cortes, o lapidador ob-\nteve, a partir da pedra maior, uma joia poliédrica \ncujos números de faces, arestas e vértices são, \nrespectivamente, iguais a: \nA) 9, 20 e 13. \nB) 9, 24 e 13. \nC) 7, 15 e 12. \nD) 10, 16 e 5. \nE) 11, 16 e 5.",
    "alternativas": {
      "A": "9, 20 e 13.",
      "B": "9, 24 e 13.",
      "C": "7, 15 e 12.",
      "E": "11, 16 e 5."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 793,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0794",
    "numero": 2294,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "O Brasil é o quarto produtor mundial de alimen-\ntos e é também um dos campeões mundiais de \ndesperdício. São produzidas por ano, aproxima-\ndamente, 150 milhões de toneladas de alimen-\ntos e, desse total, 2/3 são produtos de plantio. \nEm relação ao que se planta, 64% são perdidos \nao longo da cadeia produtiva (20% perdidos na \ncolheita, 8% no transporte e armazenamento, \n15% na indústria de processamento, 1% no \nvarejo e o restante no processamento culinário \ne hábitos alimentares). \n \nO desperdício durante o processamento culiná-\nrio e hábitos alimentares, em milhão de tonela-\nda, é igual a: \n \nA) 20. \nB) 30. \nC) 56. \nD) 64. \nE) 96.",
    "alternativas": {
      "B": "30.",
      "C": "56.",
      "D": "64.",
      "A": "20."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 794,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0795",
    "numero": 2295,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "O veiculo terrestre mais veloz já fabricado até \nhoje é o Sonic Wind LSRV, que está sendo pre-\nparado para atingir a velocidade de 3 000 km/h. \nEle é mais veloz do que o Concorde, um dos \naviões de passageiros mais rápidos já feitos, \nque alcança 2 330 km/h. \n \n \n \nPara uma distância fixa, a velocidade e o tempo \nsão inversamente proporcionais. \n \nPara percorrer uma distância de 1 000 km, o \nvalor mais próximo da diferença, em minuto, \nentre os tempos gastos pelo Sonic Wind LSRV \ne pelo Concorde, em suas velocidades máxi-\nmas, é: \n \nA) 0,1. \nB) 0,7. \nC) 6,0. \nD) 11,2. \nE) 40,2.",
    "alternativas": {
      "C": "6,0.",
      "D": "11,2.",
      "E": "40,2.",
      "B": "0,7."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 795,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0796",
    "numero": 2296,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "A bocha é um esporte jogado em canchas, que \nsão terrenos planos e nivelados, limitados por \ntablados perimétricos de madeira. O objetivo \ndesse esporte é lançar bochas, que são bolas \nfeitas de um material sintético, de maneira a \nsituá-las o mais perto possível do bolim, que é \numa bola menor feita, preferencialmente, de \naço, previamente lançada. \n \nA Figura 1 ilustra uma bocha e um bolim que \nforam jogados em uma cancha. Suponha que \num jogador tenha lançado uma bocha, de raio 5 \ncm, que tenha ficado encostada no bolim, de \nraio 2 cm, conforme ilustra a figura 2. \n \n \n \nConsidere o ponto C como o centro da bocha, e \no ponto O como o centro do bolim. Sabe-se que \nA e B são pontos em que a bocha e o bolim, \nrespectivamente, tocam o chão da cancha, e \nque a distância entre A e B é igual a d. \n \nNessas condições, qual a razão entre d e o raio \ndo bolim? \n \nA) 1 \n \nB) \n2√10\n5  \n \nC) √10\n2  \n \nD) 2 \n \nE) √10",
    "alternativas": {
      "A": "1",
      "C": "√10 2",
      "D": "2",
      "E": "√10"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 796,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0797",
    "numero": 2297,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Em um trabalho escolar, João foi convidado a \ncalcular as áreas de vários quadrados diferen-\ntes, dispostos na sequência, da esquerda para a \ndireita, como mostra a figura. \n \n \nO primeiro quadrado da sequência tem lado \nmedindo 1 cm, o segundo quadrado tem lado \nmedindo 2 cm, o terceiro quadrado tem lado \nmedindo 3 cm e assim por diante. O objetivo do \ntrabalho é identificar em quanto a área de cada \nquadrado da sequência excede a área do qua-\ndrado anterior. A área do quadrado que ocupa a \nposição n, na sequência foi representada por An. \n \nPara n ≥ 2, o valor da diferença An – An–1, em \ncentímetro quadrado, é igual a: \n \nA) 2n – 1 \nB) 2n + 1 \nC) –2n + 1 \nD) (n – 1)2 \nE) n2 – 1",
    "alternativas": {
      "A": "2n – 1",
      "B": "2n + 1",
      "D": "(n – 1)2",
      "E": "n2 – 1"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 797,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0798",
    "numero": 2298,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Um agricultor vive da plantação de morangos \nque são vendidos para uma cooperativa. A coo-\nperativa faz um contrato de compra e venda no \nqual o produtor informa a área plantada. \n \nPara permitir o crescimento adequado das plan-\ntas, as mudas de morango são plantadas no \ncentro de uma área retangular, de 10cm por \n20cm, como mostra a figura. \n \n \n \nAtualmente, sua plantação de morangos ocupa \nárea de 10000 m2, mas a cooperativa quer que \nele aumente sua produção. Para isso, o agricul-\ntor deverá aumentar a área plantada em 20%, \nmantendo o mesmo padrão de plantio. \n \nO aumento (em unidade) no número de mudas \nde morango em sua plantação deve ser de: \n \nA) 10000. \nB) 60000. \nC) 100000. \nD) 500000. \nE) 600000.",
    "alternativas": {
      "E": "600000.",
      "A": "10000.",
      "B": "60000.",
      "C": "100000."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 798,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0799",
    "numero": 2299,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Uma indústria de perfumes embala seus produ-\ntos, atualmente, em frascos esféricas de raio R, \ncom volume dado por \n4\n3 π (R)3. \n \nObservou-se que haverá redução de custos se \nforem utiliza dos frascos cilíndricos com raio da \nbase \nR\n3, cujo volume será dado por π (\nR\n3)\n2\n∙ h, \nsendo h a altura da nova embalagem. \n \nPara que seja mantida a mesma capacidade do \nfrasco esférico, a altura do frasco cilíndrico (em \ntermos de R) deverá ser igual a: \n \nA) 2R. \nB) 4R. \nC) 6R. \nD) 9R. \nE) 12R.",
    "alternativas": {
      "E": "12R.",
      "B": "4R.",
      "C": "6R.",
      "D": "9R."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 799,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0800",
    "numero": 2300,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Para evitar uma epidemia, a Secretaria de Saú-\nde de uma cidade dedetizou todos os bairros, \nde modo a evitar a proliferação do mosquito da \ndengue. Sabe-se que o número f de infectados \né dado pela função f(t) = – 2t2 + 120t (em que t é \nexpresso em dia e t = 0 é o dia anterior à primei-\nra infecção) e que tal expressão é válida para os \n60 primeiros dias da epidemia. \n \nA Secretaria de Saúde decidiu que uma segun-\nda dedetização deveria ser feita no dia em que \no número de infectados chegasse à marca de \n1600 pessoas, e uma segunda dedetização \nprecisou acontecer. \n \nA segunda dedetização começou no: \n \nA) 19° dia. \nB) 20° dia. \nC) 29° dia. \nD) 30° dia. \nE) 60° dia.",
    "alternativas": {
      "E": "60° dia.",
      "B": "20° dia.",
      "C": "29° dia.",
      "D": "30° dia."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 800,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0801",
    "numero": 2301,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Uma empresa europeia construiu um avião so-\nlar, como na figura, objetivando dar uma volta \nao mundo utilizando somente energia solar. O \navião solar tem comprimento AB igual a 20 m e \numa envergadura de asas CD igual a 60 m. \n \nPara uma feira de ciências, uma equipe de alu-\nnos fez uma maquete desse avião. A escala \nutilizada pelos alunos foi de 3:400. \n \nA envergadura CD na referida maquete, em \ncentímetro, é igual a: \n \nA) 5. \nB) 20. \nC) 45. \nD) 55. \nE) 80.",
    "alternativas": {
      "E": "80.",
      "A": "5.",
      "C": "45.",
      "D": "55."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 801,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0802",
    "numero": 2302,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "O gráfico mostra a média de produção diária de \npetróleo no Brasil, em milhão de barris, no perí-\nodo de 2004 a 2010. \n \n \n \nEstimativas feitas naquela época indicavam que \na média de produção diária de petróleo no Bra-\nsil, em 2012, seria 10% superior à média dos \ntrês últimos anos apresentados no gráfico. \n \nSe essas estimativas tivessem sido confirma-\ndas, a média de produção diária de petróleo no \nBrasil, em milhão de barris, em 2012, teria sido \nigual a: \n \nA) 1,940. \nB) 2,134. \nC) 2,167. \nD) 2,420. \nE) 6,402.",
    "alternativas": {
      "A": "1,940.",
      "B": "2,134.",
      "D": "2,420.",
      "E": "6,402."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 802,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0803",
    "numero": 2303,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "O governo de uma cidade está preocupado com \na possível epidemia de uma doença infectocon-\ntagiosa causada por bactéria. Para decidir que \nmedidas tomar, deve calcular a velocidade de \nreprodução da bactéria. Em experiências labo-\nratoriais de uma cultura bacteriana, inicialmente \ncom 40 mil unidades, obteve-se a fórmula para \na população: \np(t) = 40 ∙ 23t \nEm que t é o tempo, em hora, e p(t) é a popula-\nção, em milhares de bactérias. \n \nEm relação à quantidade inicial de bactérias, \napós 20 min, a população será: \n \nA) reduzida a um terço. \nB) reduzida à metade. \nC) reduzida a dois terços. \nD) duplicada. \nE) triplicada.",
    "alternativas": {
      "D": "duplicada.",
      "A": "reduzida a um terço.",
      "B": "reduzida à metade.",
      "C": "reduzida a dois terços."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 803,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0804",
    "numero": 2304,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Um vendedor de assinaturas de TV a cabo teve \nnos 7 primeiros meses do ano, uma média \nmensal de 84 assinaturas vendidas. Devido a \numa reestruturação da empresa, foi exigido que \ntodos os vendedores tivessem, ao final do ano, \numa média mensal de 99 assinaturas vendidas. \nDiante disso, o vendedor se viu forçado a au-\nmentar sua média mensal de vendas nos 5 me-\nses restantes do ano. \n \nQual deverá ser a média mensal de vendas do \nvendedor nos próximos 5 meses, para que ele \npossa cumprir e exigência da sua empresa? \n \nA) 91 \nB) 105 \nC) 114 \nD) 118 \nE) 120",
    "alternativas": {
      "B": "105",
      "C": "114",
      "D": "118",
      "E": "120"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 804,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0805",
    "numero": 2305,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Num mapa com escala 1 : 250000, a distância \nentre as cidades A e B é de 13 cm. Num outro \nmapa, com escala 1 : 300000, a distância entre \nas cidades A e C é de 10 cm. Em um terceiro \nmapa, com escala 1 : 500000, a distância entre \nas cidades A e D é de 9 cm. As distâncias reais \nentre a cidade A e as cidades B, C e D são, \nrespectivamente iguais a X, Y e Z (na mesma \nunidade de comprimento). \n \nAs distâncias X, Y e Z, em ordem crescente, \nestão dadas em: \n \nA) X, Y, Z. \nB) Y, X, Z. \nC) Y, Z, X. \nD) Z, X, Y. \nE) Z, Y, X.",
    "alternativas": {
      "B": "Y, X, Z.",
      "C": "Y, Z, X.",
      "D": "Z, X, Y.",
      "E": "Z, Y, X."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 805,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0806",
    "numero": 2306,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Um banco de sangue recebe 450 mL de sangue \nde cada doador. Após separar o plasma san-\nguíneo das hemácias, o primeiro é armazenado \nem bolsas de 250 mL de capacidade. O banco \nde sangue aluga refrigeradores de uma empre-\nsa para estocagem das bolsas de plasma se-\ngundo a sua necessidade. Cada refrigerador \ntem uma capacidade de estocagem de 50 bol-\nsas. Ao longo de uma semana, 100 pessoas \ndoaram sangue àquele banco. \n \nAdmita que, de cada 60 mL de sangue, extra-\nem-se 40 mL de plasma. O número mínimo de \ncongeladores que o banco preciso alugar, para \nestocar todas as bolsas de plasma dessa se-\nmana, \n \nA) 2. \nB) 3. \nC) 4. \nD) 6. \nE) 8.",
    "alternativas": {
      "A": "2.",
      "B": "3.",
      "D": "6.",
      "E": "8."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 806,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0807",
    "numero": 2307,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "O quadro apresenta a ordem de colocação dos \nseis primeiros países em um dia de disputa nas \nOlimpíadas. A ordenação é feita de acordo com \nas quantidades de medalhas de ouro, prata e \nbronze, respectivamente. \n \n \n \nSe as medalhas obtidas por Brasil e Argentina \nfosse reunidas para formar um único país hipo-\ntético, qual a posição ocupada por esse país? \n \nA) 1a. \nB) 2a. \nC) 3a. \nD) 4a. \nE) 5a.",
    "alternativas": {
      "D": "4a.",
      "E": "5a.",
      "A": "1a.",
      "B": "2a."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 807,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0808",
    "numero": 2308,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Na figura estão representadas três retas no \nplano cartesiano, sendo P, Q e R os pontos de \nintersecções entre as retas, e A, B e C s pontos \nde intersecções dessas retas com o eixo x. \nEssa figura é a representação gráfica de um \nsistema linear de três equações e duas incógni-\ntas que: \n \nA) possui três soluções reais e distintas, repre-\nsentadas pelos pontos P, Q e R, pois eles indi-\ncam onde as retas se intersectam. \nB) possui três soluções reais e distintas, repre-\nsentadas pelos pontos A, B e C, pois eles indi-\ncam onde as retas intersectam o eixo das abs-\ncissas. \nC) possui infinitas soluções reais, pois as retas \nse intersectam em mais de um ponto. \nD) não possui solução real, pois não há ponto \nque pertença simultaneamente às três retas. \nE) possui uma única solução real, pois as retas \npossuem pontos em que se intersectam.",
    "alternativas": {
      "A": "possui três soluções reais e distintas, repre- sentadas pelos pontos P, Q e R, pois eles indi- cam onde as retas se intersectam.",
      "B": "possui três soluções reais e distintas, repre- sentadas pelos pontos A, B e C, pois eles indi- cam onde as retas intersectam o eixo das abs- cissas.",
      "C": "possui infinitas soluções reais, pois as retas se intersectam em mais de um ponto.",
      "D": "não possui solução real, pois não há ponto que pertença simultaneamente às três retas."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 808,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0809",
    "numero": 2309,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Dispondo de um grande terreno, uma empresa \nde entretenimento pretende construir um espaço \nretangular para shows e eventos, conforme a \nfigura. \n \n \n \nA área para o público será cercada com dois \ntipos de materiais: \n \n• nos lados paralelos ao palco será usada uma \ntela do tipo A, mais resistente, cujo valor do \nmetro linear é R$20,00; \n• nos outros dois lados será usada uma tela do \ntipo B, comum, cujo metro linear custa R$5,00. \n \nA empresa dispõe de R$ 5 000,00 para comprar \ntodas as telas, mas quer fazer de tal maneira \nque obtenha a maior área possível para o públi-\nco. \n \nA quantidade de cada tipo de tela que a empre-\nsa deve comprar é: \n \nA) 50,0 m da tela tipo A e 800,0 m da tela tipo B. \nB) 62,5 m da tela tipo A e 250,0 m da tela tipo B. \nC) 100,0 m da tela tipo A e 600,0 m da tela tipo B. \nD) 125,0 m da tela tipo A e 500,0 m da tela tipo B. \nE) 200,0 m da tela tipo A e 200,0 m da tela tipo B.",
    "alternativas": {
      "B": "62,5 m da tela tipo A e 250,0 m da tela tipo B.",
      "C": "100,0 m da tela tipo A e 600,0 m da tela tipo B.",
      "D": "125,0 m da tela tipo A e 500,0 m da tela tipo B.",
      "A": "50,0 m da tela tipo A e 800,0 m da tela tipo B."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 809,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0810",
    "numero": 2310,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Um clube tem um campo de futebol com área \ntotal de 8000 m2, correspondente ao gramado. \nUsualmente, a poda da grama desse campo é \nfeita por duas máquinas do clube próprias para \no serviço. Trabalhando no mesmo ritmo, as \nduas máquinas podam juntas 200 m2 por hora. \n \nPor motivo de urgência na realização de uma \npartida de futebol, o administrador do campo \nprecisará solicitar ao clube vizinho máquinas \niguais às suas para fazer o serviço de poda em \num tempo máximo de 5 h. \n \nUtilizando as duas máquinas que o clube já \npossui, qual o número mínimo de máquinas que \no administrador do campo deverá solicitar ao \nclube vizinho? \n \nA) 4 \nB) 6 \nC) 8 \nD) 14 \nE) 16",
    "alternativas": {
      "E": "16",
      "B": "6",
      "C": "8",
      "D": "14"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2016.2",
    "numeroOriginal": 810,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0811",
    "numero": 2311,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Um motorista partiu da cidade A em direção à \ncidade B por meio de uma rodovia retilínea loca-\nlizada em uma planície. Lá chegando, ele per-\ncebeu que a distância percorrida nesse trecho \nfoi de 25 km. Ao consultar um mapa com o auxí-\nlio de uma régua, ele verificou que a distância \nentre essas duas cidades, nesse mapa, era de 5 \ncm. \n \nA escala desse mapa é: \n \nA) 1:5 \nB) 1:1000 \nC) 1:5000 \nD) 1:100000 \nE) 1:500000",
    "alternativas": {
      "E": "1:500000",
      "A": "1:5",
      "C": "1:5000",
      "D": "1:100000"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2016.3",
    "numeroOriginal": 811,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  }
];